var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ProjectStatus text-light text-center text-nowrap rounded d-inline-block",class:_vm.className},[_vm._v("\n  "+_vm._s(_vm.variant)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }